import createSelectors from './createSelectors';
import AnswersSheet from '../models/AnswersSheet';

const Select = createSelectors(AnswersSheet, {});

export default Select;
